<template>
    <div class="main-cn">
        <div class="main-bd mg20">
            <el-row class="searchSection">
                <el-form ref="form" :inline="true" :model="searcheModel">
                    <el-form-item label="客户名称" class="customer-input" >
                        <!-- <CustomerSelect ref="CustomerSelect" :customerIdss="searcheModel.customer_name" v-model="searcheModel.customer_name" @change="CustomerHandleChange"></CustomerSelect> -->
                        <el-input size="small" placeholder="请输客户名称" v-model="searcheModel.customer_name" :disabled="isCustomerSensitiveMasked"></el-input>
                    </el-form-item>
                    <el-form-item label="订单ID">
                        <el-input size="small" placeholder="请输入订单ID" type="number" v-model="searcheModel.order_id"></el-input>
                    </el-form-item>
                    <el-form-item label="合同开始时间">
                        <el-date-picker
                            size="small"
                            v-model="searcheModel.start_at"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="合同结束时间">
                        <el-date-picker
                            size="small"
                            v-model="searcheModel.end_at"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="收入时间">
                        <el-date-picker
                            size="small"
                            v-model="searcheModel.income_at"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" @click="submitSearch">搜索</el-button>
                        <el-button @click="resetForm()" size="small">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-row class="searchSection">
                <el-col :span="1">
                    <ImportFile 
                    :templateFileUrl="'/file/excel/确认收入导入模板.xlsx'" 
                    :url="'/api/import/finance-income'"  
                    :params="searcheModel" 
                    dialogTitle="确认收入" 
                    buttonText="导入数据" 
                    @import_success="importSuccess"
                    :err_fields="err_fields" >
                    </ImportFile>
                </el-col>
                <el-col :span="2">
                    <ExportFile 
                        :url="'/api/export/finance-income'" 
                        :params="searcheModel" 
                        filename="收入确认数据表" 
                        buttonName="导出数据" 
                        buttonType="success">
                    </ExportFile>
                </el-col>
                <el-col :span="1">
                    <el-button type="danger" size="small" @click="batchDelete" :disabled="multipleSelection.length == 0">批量删除</el-button>
                </el-col>
                <el-col :span="8" :offset="12">
                    <label>选择显示年份：</label>
                    <el-date-picker
                        v-model="start_year"
                        size="small"
                        type="year"
                        format="yyyy"
                        value-format="yyyy"
                        placeholder="选择起始年份" 
                        style="width:120px;">
                    </el-date-picker>
                    -
                    <el-date-picker
                        v-model="end_year"
                        size="small"
                        type="year"
                        format="yyyy"
                        value-format="yyyy"
                        placeholder="选择到期年份" 
                        style="width:120px;">
                    </el-date-picker>
                </el-col>
                
            </el-row>
            <el-row>
                <el-table :data="list" @selection-change="handleSelectionChange" border v-loading="loading">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="order_id" label="订单ID">
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleView(scope.row)">
                                {{ scope.row.order_id }}
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="customer_code" label="客户编码"></el-table-column>
                    <el-table-column prop="customer_name" label="客户名称">
                        <template slot-scope="scope">
                            <span v-if="scope.row.customer_sensitive_masked || !scope.row.customer_name_edit_mode" @dblclick="!scope.row.customer_sensitive_masked && startEditing(scope.row, 'customer_name_edit_mode')" style="width:100%;height:100%;">{{ scope.row.customer_name }}</span>
                            <el-input v-else v-model="scope.row.customer_name" @blur="stopEditing(scope.row, 'customer_name_edit_mode')" :ref="'customer_name_edit_mode' + scope.row.id"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="income_sn" label="收入编码">
                        <template slot-scope="scope">
                            <span v-if="!scope.row.income_sn_edit_mode" @dblclick="startEditing(scope.row, 'income_sn_edit_mode')">{{ scope.row.income_sn }}</span>
                            <el-input v-else v-model="scope.row.income_sn" @blur="stopEditing(scope.row, 'income_sn_edit_mode')" :ref="'income_sn_edit_mode' + scope.row.id"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="income_at" label="收入时间">
                        <template slot-scope="scope">
                            <span v-if="!scope.row.income_at_edit_mode" @dblclick="startEditing(scope.row, 'income_at_edit_mode')">{{ scope.row.income_at }}</span>
                            <el-date-picker v-else v-model="scope.row.income_at" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择起始时间" @blur="stopEditing(scope.row, 'income_at_edit_mode')" :ref="'income_at_edit_mode' + scope.row.id"></el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column prop="contract_amount" label="合同金额">
                        <template slot-scope="scope">
                            <span v-if="scope.row.order_sensitive_masked || !scope.row.contract_amount_edit_mode" @dblclick="!scope.row.order_sensitive_masked && startEditing(scope.row, 'contract_amount_edit_mode')">{{ scope.row.contract_amount }}</span>
                            <el-input v-else v-model="scope.row.contract_amount" type="number" @blur="stopEditing(scope.row, 'contract_amount_edit_mode')" :ref="'contract_amount_edit_mode' + scope.row.id"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="tax_amount" label="税额">
                        <template slot-scope="scope">
                            <span v-if="scope.row.order_sensitive_masked || !scope.row.tax_amount_edit_mode" @dblclick="!scope.row.order_sensitive_masked && startEditing(scope.row, 'tax_amount_edit_mode')">{{ scope.row.tax_amount }}</span>
                            <el-input v-else v-model="scope.row.tax_amount" type="number" @blur="stopEditing(scope.row, 'tax_amount_edit_mode')" :ref="'tax_amount_edit_mode' + scope.row.id"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="start_at" label="起始时间">
                        <template slot-scope="scope">
                            <span v-if="!scope.row.start_at_edit_mode" @dblclick="startEditing(scope.row, 'start_at_edit_mode')">{{ scope.row.start_at }}</span>
                            <el-date-picker v-else v-model="scope.row.start_at" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择起始时间" @blur="stopEditing(scope.row, 'start_at_edit_mode')" :ref="'start_at_edit_mode' + scope.row.id"></el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column prop="end_at" label="到期时间">
                        <template slot-scope="scope">
                            <span v-if="!scope.row.end_at_edit_mode" @dblclick="startEditing(scope.row, 'end_at_edit_mode')">{{ scope.row.end_at }}</span>
                            <el-date-picker v-else v-model="scope.row.end_at" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择起始时间" @blur="stopEditing(scope.row, 'end_at_edit_mode')" :ref="'end_at_edit_mode' + scope.row.id"></el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column prop="income_amount" label="收入"></el-table-column>
                    <el-table-column prop="month_num" label="合同期限"></el-table-column>
                    <el-table-column prop="month_income_amount" label="每期不含税收入"></el-table-column>
                    <el-table-column
                        fixed="right"
                        width="100">
                        <template slot-scope="scope">
                            <el-button @click="handleDelete([scope.row.id])" type="text" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                    <!-- 使用 v-for 循环动态生成列 -->
                    <template v-for="year in this.searcheModel.diff_arr">
                        <el-table-column :key="year + '_term'" :label="year + '年期限'">
                            <template slot-scope="scope">
                                <span v-if="scope.row.year_arr[year]">{{ scope.row.year_arr[year].month_num }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column :key="year + '_income'" :label="year + '年确认收入'">
                            <template slot-scope="scope">
                                <span v-if="scope.row.year_arr[year]">{{ scope.row.year_arr[year].income_amount }}</span>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
                <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
            </el-row>
        </div>
    </div>
  </template>
  <style scoped>
  </style>
  <script>
  import FinanceService from "~/services/finance";
  import MyPagination from "~/widgets/MyPagination.vue";
  import ExportFile from "~/widgets/ExportFile.vue";
  import UnbindDialog from "~/views/count/dialog/UnbindDialog.vue";
  import CustomerSelect from "~/widgets/CustomerSelect.vue";
  import ImportFile from "~/widgets/ImportFile.vue";
  
  export default {
    name: "income",
  
    components: {
      MyPagination,
      ExportFile,
      UnbindDialog,
      CustomerSelect,
      ImportFile,
    },
  
    props: {},
  
    data() {
      return {
        loading: false,
        searcheModel: {},
        // 分页信息
        linkPage: null,
        list: [],
        err_fields:{
            line_num: '行数',
            error_str: '异常原因',
            order_id: '订单ID',
            customer_code: '客户编码',
            customer_name: '客户名称',
            income_sn: '收入编码',
            income_at: '收入时间',
            contract_amount: '合同金额',
            tax_amount: '税额',
            start_at: '开始时间',
            end_at: '结束时间',
        },
        start_year: new Date().getFullYear().toString(),
        end_year: (new Date().getFullYear() + 3).toString(),
        multipleSelection: [],
        isCustomerSensitiveMasked: false,
        isOrderSensitiveMasked: false
      };
    },
  
    mounted() {
      
    },

    // computed: {
    //     currentView() {
    //         if(this.end_year < this.start_year){
    //             return false;
    //         }
    //         for(val i = 0; )
    //         return;
    //     }
    // },
  
    watch: {
        start_year(year){
            this.searcheModel.diff_arr = [];
            if(!year || !this.end_year || year > this.end_year){
                return;
            }
            for(let i = Number(year); i <= this.end_year;i++){
                this.searcheModel.diff_arr.push(i);
            }
        },
        
        end_year(year){
            this.searcheModel.diff_arr = [];
            if(!year || !this.start_year || year < this.start_year){
                return;
            }
            for(let i = Number(this.start_year); i <= year;i++){
                this.searcheModel.diff_arr.push(i);
            }
        }
    },
    created: function () {
      this.resetForm();
    },
  
    methods: {
  
        //重置按钮
        resetForm() {
            this.searcheModel = {
                start_at: [],
                end_at: [],
                income_at: [],
                customer_name: '',
                order_id: '',
                diff_arr: Array.from({ length: 4 }, (_, index) => {
                    return new Date().getFullYear() + index;
                }),
            };
            if(this.$refs['CustomerSelect']){
                this.$refs['CustomerSelect'].reset();
            }

            this.list = [];
            this.submitSearch();
        },
    
        // 筛选查询
        submitSearch() {
            this.getList(this.searcheModel);
        },
    
        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            FinanceService.getIncomeList(params).then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                    this.isCustomerSensitiveMasked = this.list.some(item => item.customer_sensitive_masked);
                    this.isOrderSensitiveMasked = this.list.some(item => item.order_sensitive_masked);
                    this.all_sales_num = _.reduce(this.list, (memo, item) => {
                            return memo + (Number(item.sales_num) || 0)
                        }, 0)
                }
                if (res._meta) {
                    this.linkPage = res._meta;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },
    
        handleSizeChange(newSize) {
            // 处理每页条目数变化事件
            let params = this.searcheModel;
            params['perPage'] = newSize;
            this.getList(params);
        },
  
        handleCurrentChange(newPage) {
            let params = this.searcheModel;
            // 处理当前页码变化事件
            params['page'] = newPage;
            this.getList(params);
        },

        //客户名称远程搜索组件赋值
        CustomerHandleChange(object) {
            this.searcheModel.customer_name = object.value;
        },

        // 计算合同期限的方法
        contractTerms(row) {
            const startAt = new Date(row.start_at);
            const endAt = new Date(row.end_at);

            // 使用月份差计算总期数
            const totalMonths = (endAt.getFullYear() - startAt.getFullYear()) * 12 +
                (endAt.getMonth() - startAt.getMonth()) + 1;

            return totalMonths;
        },

        importSuccess(){
            this.submitSearch();
        },

        startEditing(row, field) {
            const isCustomerField = field === 'customer_name_edit_mode';
            const isOrderField = field === 'contract_amount_edit_mode' || field === 'tax_amount_edit_mode';
            if ((isCustomerField && row.customer_sensitive_masked)
                || (isOrderField && row.order_sensitive_masked)) {
                return;
            }
            // 进入编辑模式
            this.$set(row, field, true);
            this.$nextTick(() => {
                // 在下一次 DOM 更新后聚焦到输入框
                this.$refs[field + row.id] && this.$refs[field + row.id].focus();
            });
        },

        stopEditing(row, field) {
            // 退出编辑模式
            this.$set(row, field, false);
            // 在这里你可以处理保存编辑后的数据的逻辑
            FinanceService.getIncomeUpdate(row).then((res) => {
                if (res.code == 0) {
                    this.$message({
                        message: "修改成功!",
                        type: "success",
                    });
                    this.submitSearch();
                }
            }).catch((err) => {
                console.error(err);
            });
        },

        handleView(row) {
            let params = {id: row.order_id};
            let routeData = this.$router.resolve({
                path: "/order/view",
                query: params,
            });
            window.open(routeData.href, '_blank');
        },

        handleDelete(ids){
            this.$confirm("确定要删除记录吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            }).then(() => {
                FinanceService.getIncomeDelete(ids).then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            message: "删除成功!",
                            type: "success",
                        });
                        this.submitSearch();
                    }
                }).catch((err) => {
                    console.error(err);
                });
            })
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        batchDelete(){
            const ids = this.multipleSelection.map(item => item.id)
            this.handleDelete(ids);
        }
    },
  };
  </script>



// WEBPACK FOOTER //
// src/views/finance/income.vue